import clsx from 'clsx'
import { CSSProperties } from 'react'
import FaceHappy from './face-happy.svg?react'
import FaceExcited from './face-excited.svg?react'
import FaceAww from './face-aww.svg?react'
import './blobby.css'

type ExtendedCSSProperties = CSSProperties & {
  [key: `--${string}`]: string | number | undefined
}

type BlobbyProps = {
  className?: string
  expression: 'happy' | 'excited'
  facing?: 'left' | 'right'
  style?: ExtendedCSSProperties
}

export const Blobby = ({
  expression,
  facing = 'right',
  style,
  className,
}: BlobbyProps) => {
  const Face = expression === 'excited' ? FaceExcited : FaceHappy

  return (
    <div
      className={clsx('blob', `blob-facing-${facing}`, className)}
      style={style}
    >
      <Face className="blob-face" />
    </div>
  )
}

type BlobbyAwwProps = {
  className?: string
  facing?: 'left' | 'right'
}

export const BlobbyAww = ({ facing = 'right', className }: BlobbyAwwProps) => {
  return (
    <div
      className={clsx('blob', 'blob-awww', `blob-facing-${facing}`, className)}
    >
      <FaceAww className="blob-face" />
    </div>
  )
}
